import { createContentHook } from './createContentHook';
import type { HomePageContent } from '../types/HomePageContent';

export const useHomePageContent = createContentHook<HomePageContent>('/HomePage');
